module.exports = "../images/icons-race-details/Tiplogia.svg";